export const data = {
  godwin: {
    name: "Onyerikam",
    whatWork: "SENTIMO",
    content: "I am a full time Computer Programmer and Web Developer. I am an individual who likes to be consistent and attain perfection in my work. I made this platform, Sentimo.",
    socialLinks: ["mailto:andrespedrionyerikam@gmail.com","https://facebook.com/MrOGJT","https://twitter.com/MrOGJT", "https://github.com/Onyerikam", ],
  },
};

export default data;
